var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _defs, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactMovieLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 2000,
    height: 611,
    viewBox: "0 0 2000 611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.2121212121212466,0.6439841927386851)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 121",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 611,
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.1275320578091339)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 121.25506411561827",
    height: 121.25506411561827,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 632.5018623798826 193.9068918793503",
    height: 121.25506411561827,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 8.079182653003434,
    height: 193.9068918793503,
    x: 207.75298691796962,
    y: 0,
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 0,
    stroke: "transparent",
    fillOpacity: 1,
    className: "rect-qz-0",
    "data-fill-palette-color": "primary",
    rx: "1%",
    id: "qz-0",
    "data-palette-color": "#4a596d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,236.98186237988259,0.48235545243618105)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 192.94218097447794",
    height: 192.94218097447794,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 192.94218097447794",
    height: 192.94218097447794,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 192.94218097447794",
    height: 192.94218097447794,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "0.3999999999999986 -38.35 172.4 94.3",
    height: 192.94218097447794,
    "data-palette-color": "#4a596d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), /*#__PURE__*/React.createElement("g", {
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5-6.4v0c0.767 0 1.45-0.167 2.05-0.5v0l-0.25 5.65c-1.567 1.3-3.35 1.95-5.35 1.95v0c-4.533 0-6.8-1.9-6.8-5.7v0c0-0.667 0.067-1.383 0.2-2.15v0l1.05-6.15c0.1-0.6 0.15-1.2 0.15-1.8v0c0-1.6-0.873-2.4-2.62-2.4-1.753 0-3.13 0.683-4.13 2.05v0l-2.7 15.45h-8.5l2.35-13.3c0.1-0.6 0.15-1.2 0.15-1.8v0c0-1.6-0.9-2.4-2.7-2.4v0c-1.433 0-2.667 0.55-3.7 1.65v0l-2.8 15.85h-8.5l4.25-24.05h7.9l-0.55 3c2-2.467 4.533-3.7 7.6-3.7v0c4.333 0 6.8 1.433 7.4 4.3v0c2-2.867 4.673-4.3 8.02-4.3 3.353 0 5.53 0.75 6.53 2.25v0c0.667 1.033 1 2.167 1 3.4 0 1.233-0.083 2.35-0.25 3.35v0l-1.25 7.45c-0.033 0.2-0.05 0.383-0.05 0.55v0c0 0.9 0.5 1.35 1.5 1.35zM62.45-24.75v0c3.6 0 6.317 0.783 8.15 2.35v0c1.433 1.233 2.15 2.95 2.15 5.15v0c0 0.733-0.083 1.533-0.25 2.4v0l-1.05 5.85c-0.633 3.533-2.107 6.033-4.42 7.5-2.32 1.467-5.413 2.2-9.28 2.2-3.867 0-6.7-0.733-8.5-2.2v0c-1.333-1.1-2-2.75-2-4.95v0c0-0.767 0.083-1.617 0.25-2.55v0l1.05-5.85c1.167-6.6 5.8-9.9 13.9-9.9zM63.15-10.1l0.65-3.75c0.067-0.333 0.1-0.76 0.1-1.28 0-0.513-0.217-1.087-0.65-1.72-0.433-0.633-1.19-0.95-2.27-0.95-1.087 0-1.997 0.357-2.73 1.07-0.733 0.72-1.2 1.68-1.4 2.88v0l-0.65 3.75c-0.067 0.333-0.1 0.757-0.1 1.27 0 0.52 0.217 1.08 0.65 1.68 0.433 0.6 1.193 0.9 2.28 0.9 1.08 0 1.987-0.377 2.72-1.13 0.733-0.747 1.2-1.653 1.4-2.72zM92.55-24.05h8.5c0.467 1.4 0.7 3.257 0.7 5.57 0 2.32-0.283 4.547-0.85 6.68-0.567 2.133-1.423 4.157-2.57 6.07-1.153 1.92-2.753 3.473-4.8 4.66-2.053 1.18-4.413 1.77-7.08 1.77v0c-4.167 0-7.05-0.85-8.65-2.55v0c-1.067-1.133-1.6-2.867-1.6-5.2v0c0-1.1 0.133-2.35 0.4-3.75v0l2.35-13.25h8.5l-2.35 13.3c-0.1 0.5-0.15 0.95-0.15 1.35v0c0 1.9 0.983 2.85 2.95 2.85v0c3.467 0 5.2-3.633 5.2-10.9v0c0-1.7-0.133-3.583-0.4-5.65v0zM115.1-6.4v0c0.767 0 1.45-0.167 2.05-0.5v0l-0.25 5.65c-1.567 1.3-3.35 1.95-5.35 1.95v0c-3.033 0-5-0.7-5.9-2.1v0c-0.6-0.933-0.9-1.927-0.9-2.98 0-1.047 0.067-1.97 0.2-2.77v0l3-16.9h8.5l-2.8 15.75c-0.033 0.2-0.05 0.383-0.05 0.55v0c0 0.9 0.5 1.35 1.5 1.35zM108.95-32.2v0c0-2.133 0.477-3.693 1.43-4.68 0.947-0.98 2.42-1.47 4.42-1.47v0c2.8 0 4.2 1.233 4.2 3.7v0c0 2.1-0.473 3.633-1.42 4.6-0.953 0.967-2.447 1.45-4.48 1.45v0c-2.767 0-4.15-1.2-4.15-3.6zM130.3 0.7v0c-6.933 0-10.4-2.4-10.4-7.2v0c0-0.667 0.067-1.383 0.2-2.15v0l1.05-6.2c0.567-3.2 2.043-5.66 4.43-7.38 2.38-1.713 5.537-2.57 9.47-2.57v0c6.7 0 10.05 2.533 10.05 7.6v0c0 0.733-0.067 1.533-0.2 2.4v0l-0.6 3.55h-15.25l-0.2 1.15c-0.067 0.4-0.1 0.767-0.1 1.1v0c0 1.833 1.083 2.75 3.25 2.75v0c0.8 0 1.483-0.25 2.05-0.75 0.567-0.5 0.9-1.083 1-1.75v0l8.3 0.1c-1.1 6.233-5.45 9.35-13.05 9.35zM129.55-14.3h6.75c0.133-0.567 0.2-1.093 0.2-1.58 0-0.48-0.217-0.97-0.65-1.47-0.433-0.5-1.123-0.75-2.07-0.75-0.953 0-1.82 0.317-2.6 0.95-0.787 0.633-1.33 1.583-1.63 2.85zM172.8-18.85v0c0 1.1-0.333 2.117-1 3.05v0h-8.2c0.267-0.2 0.4-0.533 0.4-1 0-0.467-0.267-0.843-0.8-1.13-0.533-0.28-1.217-0.42-2.05-0.42v0c-2.5 0-3.75 0.767-3.75 2.3v0c0 0.6 0.467 1.033 1.4 1.3 0.933 0.267 2.067 0.483 3.4 0.65 1.333 0.167 2.667 0.407 4 0.72 1.333 0.32 2.467 0.947 3.4 1.88 0.933 0.933 1.4 2.183 1.4 3.75v0c0 2.767-1.107 4.867-3.32 6.3-2.22 1.433-5.447 2.15-9.68 2.15-4.233 0-7.2-0.683-8.9-2.05v0c-1.333-1.067-2-2.533-2-4.4v0c0-0.533 0.05-1.083 0.15-1.65v0l8.35-0.1c-0.067 0.467 0.21 0.873 0.83 1.22 0.613 0.353 1.52 0.53 2.72 0.53 1.2 0 2.067-0.127 2.6-0.38 0.533-0.247 0.8-0.72 0.8-1.42v0c0-0.467-0.467-0.793-1.4-0.98-0.933-0.18-2.073-0.337-3.42-0.47-1.353-0.133-2.703-0.35-4.05-0.65-1.353-0.3-2.497-0.933-3.43-1.9-0.933-0.967-1.4-2.233-1.4-3.8v0c0-3.033 1.177-5.367 3.53-7 2.347-1.633 5.737-2.45 10.17-2.45v0c6.833 0 10.25 1.983 10.25 5.95z",
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "primary",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,42.05)",
    d: "M24.55-7.7v0c0 0.867 0.443 1.3 1.33 1.3 0.88 0 1.62-0.167 2.22-0.5v0l-0.25 5.65c-1.6 1.3-3.4 1.95-5.4 1.95v0c-3.667 0-5.7-1.333-6.1-4v0c-1.667 2.667-4.117 4-7.35 4v0c-5.467 0-8.2-2.35-8.2-7.05v0c0-0.8 0.083-1.683 0.25-2.65v0l1.05-5.85c0.533-3 1.76-5.393 3.68-7.18 1.913-1.78 4.413-2.67 7.5-2.67 3.08 0 5.17 0.717 6.27 2.15v0l0.25-1.5h7.6l-2.8 15.75c-0.033 0.2-0.05 0.4-0.05 0.6zM10.4-13.85l-0.65 3.75c-0.067 0.3-0.1 0.717-0.1 1.25 0 0.533 0.25 1.057 0.75 1.57 0.5 0.52 1.343 0.78 2.53 0.78 1.18 0 2.203-0.467 3.07-1.4v0l1.5-8.4c-0.367-0.833-1.233-1.25-2.6-1.25v0c-2.567 0-4.067 1.233-4.5 3.7zM48.55-24.7v0c3.4 0 5.75 0.9 7.05 2.7v0c0.933 1.233 1.4 2.8 1.4 4.7v0c0 0.767-0.083 1.583-0.25 2.45v0l-1 5.85c-0.567 3.167-1.783 5.573-3.65 7.22-1.867 1.653-4.2 2.48-7 2.48-2.8 0-4.75-0.75-5.85-2.25v0l-2.7 15.45h-8.5l6.7-37.95h7.7l-0.25 1.35c1.567-1.333 3.683-2 6.35-2zM43.35-6.5v0c0.933 0 1.8-0.3 2.6-0.9 0.8-0.6 1.3-1.5 1.5-2.7v0l0.65-3.75c0.067-0.333 0.1-0.75 0.1-1.25 0-0.5-0.217-1.033-0.65-1.6-0.433-0.567-1.183-0.85-2.25-0.85v0c-1.733 0-2.867 0.417-3.4 1.25v0l-1.5 8.4c0.467 0.933 1.45 1.4 2.95 1.4zM77.35-24.7v0c3.4 0 5.75 0.9 7.05 2.7v0c0.933 1.233 1.4 2.8 1.4 4.7v0c0 0.767-0.083 1.583-0.25 2.45v0l-1 5.85c-0.567 3.167-1.783 5.573-3.65 7.22-1.867 1.653-4.2 2.48-7 2.48-2.8 0-4.75-0.75-5.85-2.25v0l-2.7 15.45h-8.5l6.7-37.95h7.7l-0.25 1.35c1.567-1.333 3.683-2 6.35-2zM72.15-6.5v0c0.933 0 1.8-0.3 2.6-0.9 0.8-0.6 1.3-1.5 1.5-2.7v0l0.65-3.75c0.067-0.333 0.1-0.75 0.1-1.25 0-0.5-0.217-1.033-0.65-1.6-0.433-0.567-1.183-0.85-2.25-0.85v0c-1.733 0-2.867 0.417-3.4 1.25v0l-1.5 8.4c0.467 0.933 1.45 1.4 2.95 1.4z",
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "primary",
    opacity: 1
  })))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.48235545243619526)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 186.6032941090601 192.9421809744779",
    height: 192.9421809744779,
    width: 186.6032941090601,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "7.487339512935998 6.066 84.025660487064 86.88",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 192.9421809744779,
    width: 186.6032941090601,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.571,
    y: 16.321,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.571,
    y: 28.368,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.571,
    y: 40.416,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.571,
    y: 52.464,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.349,
    y: 16.321,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.349,
    y: 28.368,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80.349,
    y: 40.416,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80.349,
    y: 52.464,
    fill: "#ffffff",
    width: 5.716,
    height: 5.716,
    "data-fill-palette-color": "accent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M52.324 50.356c-0.188 0-0.375-0.048-0.546-0.142-0.354-0.199-0.572-0.572-0.572-0.975V26.271c0-0.404 0.218-0.777 0.572-0.975 0.354-0.194 0.786-0.19 1.13 0.024l18.704 11.483c0.332 0.203 0.532 0.563 0.532 0.951 0 0.389-0.201 0.749-0.532 0.951L52.909 50.19C52.73 50.301 52.527 50.356 52.324 50.356zM53.442 28.268v18.974l15.45-9.488L53.442 28.268z",
    "data-fill-palette-color": "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M81.978 8.301c4.025 0 7.3 3.275 7.3 7.3V59.3c0 4.025-3.275 7.3-7.3 7.3H38.279c-4.025 0-7.3-3.275-7.3-7.3V15.601c0-4.025 3.275-7.3 7.3-7.3H81.978M81.978 6.066H38.279c-5.266 0-9.535 4.269-9.535 9.535V59.3c0 5.266 4.269 9.535 9.535 9.535h43.699c5.266 0 9.535-4.269 9.535-9.535V15.601C91.512 10.335 87.243 6.066 81.978 6.066L81.978 6.066z",
    "data-fill-palette-color": "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M74.63 71.069h-2.299l0.225 0.924c0.478 1.957 0.164 3.985-0.884 5.706-1.048 1.722-2.704 2.931-4.661 3.409l-38.573 9.386c-1.953 0.474-3.98 0.164-5.706-0.886-1.722-1.047-2.931-2.704-3.409-4.661l-9.383-38.57c-0.478-1.957-0.161-3.985 0.886-5.706 1.047-1.722 2.704-2.931 4.661-3.409l11.023-2.682V32.28l-11.551 2.809c-2.538 0.618-4.683 2.187-6.043 4.419-1.357 2.23-1.765 4.858-1.148 7.396l9.386 38.57c0.615 2.538 2.184 4.683 4.417 6.043 1.552 0.943 3.293 1.429 5.065 1.429 0.775 0 1.558-0.094 2.331-0.284l38.573-9.386c2.538-0.615 4.683-2.184 6.04-4.417 1.36-2.23 1.765-4.858 1.148-7.396L74.63 71.069z",
    "data-fill-palette-color": "accent"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 121.25506411561827,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactMovieLogo);
export default __webpack_public_path__ + "static/media/react-movie-logo.d55736444378729233edb8efc0c78b37.svg";
export { ForwardRef as ReactComponent };